import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPencil1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6438 1.22289C12.4355 1.01461 12.0978 1.01461 11.8896 1.22289L3.96219 9.15026C3.86623 9.24622 3.78947 9.3596 3.73601 9.48433L2.17647 13.1232C2.09056 13.3237 2.13535 13.5563 2.28956 13.7105C2.44377 13.8647 2.67632 13.9095 2.87677 13.8236L6.5157 12.264C6.64043 12.2106 6.75381 12.1338 6.84977 12.0379L14.7772 4.11047C14.9854 3.90219 14.9854 3.5645 14.7772 3.35623L12.6438 1.22289ZM4.71644 9.90452L12.2667 2.35426L13.6458 3.73335L6.09552 11.2836L4.50052 11.9672L4.03287 11.4995L4.71644 9.90452Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPencil1)
const IconSvgPencil1 = createIcon(ForwardRef, 'SvgPencil1')
export default IconSvgPencil1
